// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__krAUm","heading":"style_heading__sf49v g-type-display-4"};